<template>
  <!-- 新建产品信息 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="50%"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      <a-form-model
        ref="formRef"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="right"
        :rules="formRules"
      >
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="产品名称" prop="productName">
              <a-input
                v-model="form.productName"
                style="width: 100%;"
                placeholder="产品名称限制在50个字内"
                allow-clear
                :max-length="50"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="型号">
              <a-input
                v-model="form.type"
                style="width: 100%;"
                placeholder="型号限制在50个字内"
                allow-clear
                :max-length="50"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="规格">
              <a-input v-model="form.specification" style="width: 100%;" allow-clear />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="产品类别">
              <a-select
                v-if="proTypeList.length"
                @change="typeChange"
                v-model="form.productType"
                placeholder="请选择产品类别"
                style="width: 100%;"
              >
                <a-select-option
                  v-for="(item,index) in proTypeList"
                  :key="index"
                  :value="item.value"
                >{{item.label}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="isPurApply">
          <a-col :span="12">
            <a-form-model-item label="零售价格">
              <!-- <a-input v-model="form.price" /> -->
              <a-input-number
                v-model="form.price"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="成本价格">
              <!-- <a-input v-model="form.price" /> -->
              <a-input-number
                v-model="form.productCost"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-else>
          <a-col :span="12">
            <a-form-model-item label="零售价格" prop="price">
              <a-input-number
                v-model="form.price"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="成本价格" prop="productCost">
              <a-input-number
                v-model="form.productCost"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="产品单位" prop="unit">
              <a-input
                v-model="form.unit"
                style="width: 100%;"
                placeholder="产品单位限制在5个字内"
                allow-clear
                :max-length="5"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="重量(千克)">
              <!-- <a-input v-model="form.weight" /> -->
              <a-input-number v-model="form.weight" :min="0" style="width: 100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="状态">
              <a-radio-group v-model="form.status">
                <a-radio :value="0">在售</a-radio>
                <a-radio :value="1">停售</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否计算库存">
              <a-radio-group v-model="form.isStock">
                <a-radio :value="0">计算</a-radio>
                <a-radio :value="1">不计算</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="库存上限">
              <a-input v-model="form.stockMax" style="width: 100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="库存下限">
              <a-input v-model="form.stockMin" style="width: 100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="产品说明" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <a-input v-model="form.productExplain" type="textarea" :atutosize="{ minRows: 10 }" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <upload-attachment ref="uploadRef" :val-name="valName" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <a-button @click="handleCancel" style="background-color:#F2F2F2">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import uploadAttachment from '../../common/Upload.vue'

export default {
  name: 'AddEdit',
  components: { uploadAttachment },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isPurApply: { // 采购申请进入零售价，成本价非必填
      type: Boolean,
      default: false
    },
    proTypeList: {
      type: Array,
      default: () => []
    }
  },
  provide () {
    return {
      formData: this
    }
  },
  data () {
    return {
      uploadFileList: [],
      valName: 'uploadFileList',
      form: {
        status: 0,
        isStock: 0,
        price: 0,
        productCost: 0
      },
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      formRules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请填写产品价格', trigger: 'blur' }
        ],
        productCost: [
          { required: true, message: '请填写成本价格', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        unit: [
          { required: true, message: '请输入单位', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  methods: {
    setPrice () { // 采购申请进入成本价零售价为空
      this.$set(this.form, 'productCost', null)
      this.$set(this.form, 'price', null)
    },
    typeChange (val) {
      this.form.productType = val
    },
    setForm (formValue) {
      this.form = { ...formValue }
      if (this.form.fileIds) {
        // string 转 数组  循环获取附件信息
        let fileList = this.form.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef.getFile(fileList)
        })
      }
    },
    timeChange (date, dateString) {
      this.form.useDate = dateString
    },
    detailClick () {
      this.detailVisible = true
    },
    detailClose () {
      this.detailVisible = false
    },
    handleOk () {
      // if (!this.form.price) this.$set(this.form, 'price', 0)
      this.$refs.formRef.validate((valid) => {
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        if (valid) {
          this.loading = true
          if (this.title === `[新建]-${this.$tree([], 'purchase/productManage/index')}`) {
            this.$post('/product/add', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          } else {
            this.$post('/product/update', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        }
      })
    },
    resetForm () {
      this.uploadFileList = []
      setTimeout(() => {
        this.form = {
          status: 0,
          isStock: 0,
          price: 0,
          productCost: 0
        }
      }, 500)
    },
    handleCancel () {
      this.resetForm()
      this.$emit('close')
    }
  }
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/views/purchase/productManage/addEdit.vue